import React, { useState, useEffect, useRef, useContext } from "react";
import { Paginator } from "primereact/paginator";
import {
  getLoanList,
  postLoanAddUpdate,
  postLoanDelete,
} from "./Services/PayrollService";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import * as Yup from "yup";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { TostMsg } from "../../../App";

const LoanManagement = () => {
  const [loanSummery, setLoanSummery] = useState([]);
  const [loanStatusList, setLoanStatusList] = useState([]);
  const [loanTypesList, setLoanTypesList] = useState([]);
  const [EmployeeList, setEmployeeList] = useState([]);
  const [formonthList, setFormonthList] = useState([]);
  const [arrears, setArrears] = useState([]);
  const [incentives, setIncentives] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const searchTimeout = useRef(null);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let toaster = useContext(TostMsg);

  // Form State
  const [formData, setFormData] = useState({
    EmployeeName: "",
    LoanTypeName: "",
    amount: "",
    date: "",
    Tenure: "",
    MonthlyEMI: "",
    LoanStatusName: 101,
    FinanceReferenceNumber: "",
    Notes: "",
    start: "", // First Deduction
  });

  const [formErrors, setFormErrors] = useState({});

  // Yup Validation Schema for Loans
  const loanValidationSchema = Yup.object().shape({
    EmployeeName: Yup.string().required("Employee is required"),
    LoanTypeName: Yup.string().required("Loan Type is required"),
    amount: Yup.number()
      .required("Amount is required")
      .typeError("Please enter a valid amount")
      .min(1, "Amount must be at least ₹1")
      .max(10000000, "Amount cannot exceed ₹1,00,00,000"),
    date: Yup.date()
      .required("Disbursement Date is required")
      .typeError("Please select a valid date"),
    Tenure: Yup.number()
      .required("Tenure is required")
      .typeError("Please enter a valid number of months")

      .min(1, "Tenure must be at least 1 month")
      .max(120, "Tenure cannot exceed 120 months"),
    MonthlyEMI: Yup.number()
      .typeError("Please enter a valid EMI amount")
      .min(1, "EMI must be at least ₹1")
      .max(1000000, "EMI cannot exceed ₹10,00,000"),
    LoanStatusName: Yup.string().required("Status is required"),
    FinanceReferenceNumber: Yup.string().max(
      50,
      "Reference number cannot exceed 50 characters",
    ),
    Notes: Yup.string().max(500, "Notes cannot exceed 500 characters"),
  });

  useEffect(() => {
    getMasterData();
    GetEmployeeList();
  }, []);

  const GetEmployeeList = async () => {
    let params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EpmId,
      IsDirectReportOrHierarchy: 0,
      EmployeeId: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsSuggestedOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
    };
    try {
      let res = await getEmployeeList(params);
      console.log(res.Data);
      setEmployeeList(res.Data);
    } catch (error) {
      console.error("Error fetching employee list:", error);
    }
  };

  const getMasterData = async () => {
    try {
      // setIsloading(true);

      const statusParams = {
        masterType: "LoanStatus",
        allRecords: true,
        organisationId: userDetails?.OrgId,
      };

      const typeParams = {
        masterType: "LoanTypes",
        allRecords: true,
        organisationId: userDetails?.OrgId,
      };

      const formonthParams = {
        masterType: "formonth",
        allRecords: true,
        organisationId: userDetails?.OrgId,
      };

      const [statusRes, typeResm, formonthRes] = await Promise.all([
        GetMasterTypeData(statusParams),
        GetMasterTypeData(typeParams),
        GetMasterTypeData(formonthParams),
      ]);

      setLoanStatusList(statusRes?.Data || []);
      setLoanTypesList(typeResm?.Data || []);
      setFormonthList(formonthRes?.Data || []);
    } catch (error) {
      // toster.current.error(ERROR_LIST?.MasterDataType);
    } finally {
      // setIsloading(false);
    }
  };

  const GetLoanList = async (page = 1, size = rows) => {
    console.log(filterType, "filter type--");
    // const typeData = loanTypesList?.find((t) => t.Name === filterType);
    // const statusData = loanStatusList?.find((s) => s.Name === filterStatus);

    let params = {
      LoanId: 0,
      LoggedInEmpId: 0,
      OrgId: userDetails?.OrgId,
      GUID: "",
      EmpId: 0,
      PageNumber: page,
      PageSize: size,
      Search: searchQuery || "",
      LoanStatusId: filterStatus || "",
      LoanTypeId: filterType || "",
    };
    try {
      let res = await getLoanList(params);
      setLoanSummery(res?.Data?.LoanSummary);
      setIncentives(res?.Data?.LoanItems || []);
      setTotalRecords(
        res?.Data?.RecordCount ||
          res?.Data?.TotalRecords ||
          res?.Data?.TotalCount ||
          res?.Data?.LoanItems?.length ||
          0,
      );
    } catch (error) {
      console.error("Error fetching loan list:", error);
    }
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    const page = event.first / event.rows + 1;
    GetLoanList(page, event.rows);
  };

  const PostLoanAddUpdate = async (params) => {
    try {
      let res = await postLoanAddUpdate(params);
      if (res?.StatusCode === 2000) {
        GetLoanList(1, rows);
        setFirst(0);
        closeForm();
        toaster.current.success(`Loan ${params.Id ? "updated" : "added"} successfully`);
        // return { success: true };
      } else {
        toaster.current.error(
          res?.Message || "Error saving loan. Please try again.",
        );
        // return { success: false, error: res?.Message || 'Error saving loan. Please try again.' };
      }
    } catch (error) {
      console.error("Error saving loan:", error);
      toaster.current.error("Error saving loan. Please try again.");
      // return { success: false, error: error.message || 'Error saving loan' };
    }
  };

  const PostLoanDelete = async (params) => {
    try {
      let res = await postLoanDelete(params);
      console.log("Delete API Response:", res);
      if (res?.StatusCode === 2000) {
        toaster.current.success("Loan deleted successfully");
        return { success: true };
      } else {
        toaster.current.error(
          res?.Message || "Error deleting loan. Please try again.",
        );

        console.error("Delete API Error:", res?.Message || "Unknown error");
        return {
          success: false,
          error:
            res?.Message || "Error deleting reimbursement. Please try again.",
        };
      }
    } catch (error) {
      console.error("Error deleting reimbursement:", error);
      return {
        success: false,
        error: error.message || "Error deleting reimbursement",
      };
    }
  };

  const [nextId, setNextId] = useState(8);
  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterStatus, setFilterStatus] = useState("");

  useEffect(() => {
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      GetLoanList(1, rows);
      setFirst(0);
    }, 500);
    return () => clearTimeout(searchTimeout.current);
  }, [searchQuery, filterType, filterStatus]);

  // Modal States
  const [showFormModal, setShowFormModal] = useState(false);
  const [showStmtModal, setShowStmtModal] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);

  const [stmtData, setStmtData] = useState(null);

  // Helper Functions
  const rup = (n) => (n ? "₹" + n.toLocaleString("en-IN") : "—");
  const bal = (l) => Math.max(0, l.LoanAmount - l.Repaid);
  const remEMI = (l) => (l.MonthlyEMI ? Math.ceil(bal(l) / l.MonthlyEMI) : 0);
  const pct = (l) =>
    l.LoanAmount
      ? Math.min(100, Math.round((l.Repaid / l.LoanAmount) * 100))
      : 0;

  const fmtDate = (d) => {
    if (!d) return "—";
    const dt = new Date(d);
    return dt.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // Server-side filtering — incentives already contains the filtered page
  // renderList builds rows from server data
  const renderList = () => {
    const data = incentives;
    const totalDisbursed = data.reduce((a, l) => a + (l.LoanAmount || 0), 0);
    const totalRepaid = data.reduce((a, l) => a + (l.Repaid || 0), 0);
    const totalBal = data.reduce((a, l) => a + bal(l), 0);
    const activeLoans = data.filter((l) => l.LoanStatusName === 101);
    const totalEMI = activeLoans.reduce((a, l) => a + (l.MonthlyEMI || 0), 0);

    return {
      rows: data.map((l) => {
        const b = bal(l);
        const r = remEMI(l);
        const p = pct(l);
        const sc =
          l.LoanStatusName === "Active"
            ? "badge-active"
            : l.LoanStatusName === "Closed"
              ? "badge-paid"
              : "badge-locked";
        const pb =
          l.LoanStatusName === "Closed"
            ? "var(--success)"
            : p > 75
              ? "var(--success)"
              : p > 40
                ? "var(--warning)"
                : "var(--brand)";

        return (
          <tr key={l.Id}>
            <td>
              <span style={{ fontWeight: 600 }}>{l.EmployeeName}</span>
              <br />
              <code style={{ fontSize: "10px", color: "var(--brand)" }}>
                {l.EmpId}
              </code>
            </td>
            <td>
              <span
                className="badge badge-account"
                style={{ fontSize: "10.5px" }}
              >
                {l.LoanTypeName}
              </span>
            </td>
            <td className="tr">{rup(l.LoanAmount)}</td>
            <td
              className="tr"
              style={{ fontSize: "11.5px", color: "var(--text-muted)" }}
            >
              {fmtDate(l.DisbursedOn)}
            </td>
            <td className="tr">{l.Tenure} mo.</td>
            <td className="tr">{rup(l.MonthlyEMI)}</td>
            <td className="tr" style={{ color: "var(--success)" }}>
              {rup(l.Repaid)}
            </td>
            <td
              className="tr"
              style={{
                fontWeight: 700,
                color: b > 0 ? "#92400e" : "var(--success)",
              }}
            >
              {b > 0 ? (
                rup(b)
              ) : (
                <span style={{ color: "var(--success)" }}>Nil</span>
              )}
            </td>
            <td className="tr">
              {r > 0 ? (
                `${r} EMIs`
              ) : (
                <span style={{ color: "var(--success)" }}>Done</span>
              )}
            </td>
            <td style={{ minWidth: "100px" }}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                <div className="pbar-wrap" style={{ flex: 1 }}>
                  <div
                    className="pbar-fill"
                    style={{ width: `${p}%`, background: pb }}
                  ></div>
                </div>
                <span
                  style={{ fontSize: "10.5px", fontWeight: 700, color: pb }}
                >
                  {p}%
                </span>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              <span className={`badge ${sc}`}>{l.LoanStatusName}</span>
            </td>
            <td style={{ textAlign: "center" }} className="no-print">
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  justifyContent: "center",
                }}
              >
                <button
                  className="btn btn-light btn-sm"
                  onClick={() => viewStmt(l.Id)}
                  title="Repayment Statement"
                >
                  <i className="fa-solid fa-file-lines"></i>
                </button>
                <button
                  className="btn btn-light btn-sm"
                  onClick={() => openEdit(l.Id)}
                  title="Edit"
                >
                  <i className="fa-solid fa-pen"></i>
                </button>
                <button
                  className="btn btn-light btn-sm"
                  onClick={() => askDelete(l.Id)}
                  title="Delete"
                  style={{ color: "var(--danger)" }}
                >
                  <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        );
      }),
      summary: {
        active: activeLoans.length,
        disbursed: rup(totalDisbursed),
        Repaid: rup(totalRepaid),
        bal: rup(totalBal),
        MonthlyEMI: rup(totalEMI),
        count: data.length + " records",
        ftAmt: rup(totalDisbursed),
        ftEmi: rup(totalEMI),
        ftRep: rup(totalRepaid),
        ftBal: rup(totalBal),
      },
    };
  };

  const filteredData = renderList();

  // Form Handlers
  const clearForm = () => {
    setFormData({
      EmployeeName: "",
      LoanTypeName: "",
      amount: "",
      date: "",
      Tenure: "",
      MonthlyEMI: "",
      LoanStatusName: 101,
      FinanceReferenceNumber: "",
      Notes: "",
      start: "",
    });
    setFormErrors({});
  };

  const openAdd = () => {
    setEditId(null);
    clearForm();
    setShowFormModal(true);
  };

  const openEdit = (Id) => {
    const loan = incentives.find((l) => l.Id === Id);
    if (!loan) return;

    setEditId(Id);
    setFormData({
      EmployeeName: `${loan.EmployeeName}|${loan.EmpId}`,
      LoanTypeName: loan.LoanTypeId,
      amount: loan.LoanAmount,
      date: loan?.DisbursedOn
        ? new Date(loan.DisbursedOn).toISOString().split("T")[0]
        : "-",
      Tenure: loan.Tenure,
      MonthlyEMI: loan.MonthlyEMI,
      LoanStatusName: loan.LoanStatusId,
      FinanceReferenceNumber: loan.FinanceReferenceNumber || "",
      Notes: loan.Notes || "",
      start: loan.FirstDeduction || "",
    });
    setFormErrors({});
    setShowFormModal(true);
  };

  const closeForm = () => {
    setShowFormModal(false);
  };

  const handleInputChange = (e) => {
    const { id, name, value, type } = e.target;
    const fieldName = id || name; // Use name as fallback if id is not available

    if (!fieldName) return; // Exit if neither id nor name is available

    const cleanFieldName = fieldName.replace("f-", "");
    const newFormData = { ...formData, [cleanFieldName]: value };
    setFormData(newFormData);

    // Clear validation error when user starts typing valid data
    if (formErrors[cleanFieldName]) {
      // Only clear error if the input is becoming valid
      if (type === "number" && value && !isNaN(value)) {
        setFormErrors((prev) => ({ ...prev, [cleanFieldName]: "" }));
      } else if (type === "date" && value) {
        setFormErrors((prev) => ({ ...prev, [cleanFieldName]: "" }));
      } else if (
        type === "text" &&
        value.length <= (cleanFieldName === "FinanceReferenceNumber" ? 50 : 500)
      ) {
        setFormErrors((prev) => ({ ...prev, [cleanFieldName]: "" }));
      } else if (type === "select-one" && value) {
        setFormErrors((prev) => ({ ...prev, [cleanFieldName]: "" }));
      }
    }
  };

  const validateField = async (fieldName, value) => {
    try {
      await loanValidationSchema.validateAt(fieldName, { [fieldName]: value });
      setFormErrors((prev) => ({ ...prev, [fieldName]: "" }));
    } catch (error) {
      setFormErrors((prev) => ({ ...prev, [fieldName]: error.message }));
    }
  };

  const validateForm = async () => {
    try {
      await loanValidationSchema.validate(formData, { abortEarly: false });
      setFormErrors({});
      return true;
    } catch (error) {
      const errors = {};
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
      setFormErrors(errors);
      return false;
    }
  };

  const previewEMI = () => {
    const LoanAmount = parseFloat(formData.amount) || 0;
    const ten = parseInt(formData.Tenure) || 0;

    if (LoanAmount && ten) {
      const MonthlyEMI = Math.ceil(LoanAmount / ten);
      setFormData((prev) => {
        // Only update if the EMI has actually changed
        if (prev.MonthlyEMI !== MonthlyEMI) {
          return { ...prev, MonthlyEMI: MonthlyEMI };
        }
        return prev;
      });
    }
  };

  const saveLoan = async () => {
    const isValid = await validateForm();
    if (!isValid) {
      // alert('Please fix the validation errors before saving.');
      return;
    }

    const {
      EmployeeName,
      LoanTypeName,
      amount,
      date,
      Tenure,
      MonthlyEMI,
      LoanStatusName,
      FinanceReferenceNumber,
      Notes,
      start,
    } = formData;
    const LoanAmount = parseFloat(amount) || 0;
    const ten = parseInt(Tenure) || 0;
    const finalEmi = parseInt(MonthlyEMI) || Math.ceil(LoanAmount / ten);

    const [empName, EmpId] = EmployeeName.includes("|")
      ? EmployeeName.split("|")
      : [EmployeeName, ""];

    // Prepare params for API
    const params = {
      Id: editId || 0,
      OrgId: userDetails?.OrgId,
      EmpId: Number(EmpId?.trim()) || 0,
      LoanTypeId: LoanTypeName,
      LoanStatusId: LoanStatusName,
      FirstDeduction: start,
      LoanAmount,
      PaidAmount: 0,
      DisbursementDate: date,
      Tenure: ten,
      MonthlyEMI: finalEmi,
      FinanceReferenceNumber,
      Notes,
    };

    try {
      // if (formData?.valid) {

        const result = await PostLoanAddUpdate(params);
      // } else {
      //   await loanValidationSchema.validate(formData, { abortEarly: false });
      // }
    } catch (error) {
      console.error("Error saving loan:", error);
      // alert('Error saving loan');
    }
  };

  const askDelete = (Id) => {
    setDeleteId(Id);
    setShowDelModal(true);
  };

  const confirmDelete = async () => {
    try {
      const loanToDelete = incentives.find((l) => l.Id === deleteId);
      if (!loanToDelete) {
        // alert('Loan not found');
        return;
      }

      const params = {
        // LoanId: deleteId,
        // OrgId: userDetails?.OrgId,
        RequestId: deleteId,
      };

      const result = await PostLoanDelete(params);
      if (result.success) {
        setShowDelModal(false);
        setDeleteId(null);
        await GetLoanList();
      }
    } catch (error) {
      console.error("Error deleting loan:", error);
      // alert('Error deleting loan');
    }
  };

  const viewStmt = (Id) => {
    const loan = incentives.find((l) => l.Id === Id);
    if (!loan) return;

    const rows = [];
    let opening = loan.LoanAmount;
    const start = new Date(loan.date);
    const paidEMIs = Math.round(loan.Repaid / loan.MonthlyEMI);

    for (let i = 1; i <= loan.Tenure; i++) {
      const d = new Date(start);
      d.setMonth(d.getMonth() + i);
      const mon = d.toLocaleDateString("en-IN", {
        month: "short",
        year: "numeric",
      });
      const closing = Math.max(0, opening - loan.MonthlyEMI);
      const st =
        i <= paidEMIs ? "Paid" : i === paidEMIs + 1 ? "Current" : "Upcoming";

      rows.push({
        no: i,
        mon,
        opening,
        MonthlyEMI: loan.MonthlyEMI,
        closing,
        st,
      });
      opening = closing;
    }

    const p = pct(loan);

    setStmtData({ loan, rows, p, paidEMIs });
    setShowStmtModal(true);
  };

  const closeStmt = () => {
    setShowStmtModal(false);
  };

  // Update preview when amount or Tenure changes
  useEffect(() => {
    if (showFormModal && formData.amount && formData.Tenure) {
      previewEMI();
    }
  }, [formData.amount, formData.Tenure, showFormModal]);

  const filtered = renderList();

  const handleExport = () => {
    if (!incentives.length) {
      // alert("No data to export");
      return;
    }

    const headers = [
      "Employee",
      "Employee ID",
      "Type",
      "Amount",
      "Disbursed Date",
      "Tenure",
      "EMI",
      "Repaid",
      "Balance",
      "Status",
    ];

    const csvRows = incentives.map((l) => [
      l.EmployeeName,
      l.EmpId,
      l.LoanTypeName,
      l.LoanAmount,
      l.date,
      l.Tenure,
      l.MonthlyEMI,
      l.Repaid,
      l.LoanAmount - l.Repaid,
      l.LoanStatusName,
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...csvRows].map((e) => e.join(",")).join("\n");

    const link = document.createElement("a");
    link.href = encodeURI(csvContent);
    link.download = "loan_data.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="container-fluid">
      <div className="form-head d-flex flex-wrap align-items-center page-head mb-0">
        <div className="me-auto">
          <h2 className="font-w600 mb-0">Loan Management</h2>
          <p>
            Only approved loanStatusList added here flow into payroll processing
            (Step 3 of Run Payroll)
          </p>
        </div>
        <div className="rightside-tabs">
          <div className="topbar-actions">
            <button className="btn btn-light btn-sm" onClick={handleExport}>
              <i className="fa-solid fa-file-excel"></i> Export
            </button>
            <button className="btn btn-brand btn-sm" onClick={openAdd}>
              <i className="fa-solid fa-plus"></i> Add Loan
            </button>
          </div>
        </div>
      </div>

      <div className="page-content">
        {/* SUMMARY CARDS */}
        <div className="loan-summary-grid">
          <div className="loan-summary-card">
            <div className="loan-summary-label">Active Loans</div>
            <div className="loan-summary-value" Id="sum-active">
              {loanSummery?.ActiveLoans || 0}
            </div>
          </div>
          <div className="loan-summary-card">
            <div className="loan-summary-label">Total Disbursed</div>
            <div className="loan-summary-value">
              {rup(loanSummery?.TotalDisbursed || 0)}
            </div>
          </div>
          <div className="loan-summary-card">
            <div className="loan-summary-label">Total Repaid</div>
            <div className="loan-summary-value">
              {rup(loanSummery?.TotalRepaid || 0)}
            </div>
          </div>
          <div className="loan-summary-card">
            <div className="loan-summary-label">Outstanding</div>
            <div className="loan-summary-value">
              {rup(loanSummery?.Outstanding || 0)}
            </div>
          </div>
          <div className="loan-summary-card">
            <div className="loan-summary-label">This Month EMI Total</div>
            <div className="loan-summary-value">
              {rup(loanSummery?.ThisMonthEMITotal || 0)}
            </div>
          </div>
        </div>

        {/* LOAN TABLE */}
        <div className="card" style={{ overflow: "hidden" }}>
          <div className="toolbar">
            <input
              type="text"
              className="form-control"
              placeholder="Search employee…"
              style={{ width: "200px" }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <div className="toolbar-sep"></div>

            <select
              className="form-select"
              style={{ width: "140px" }}
              value={filterType}
              onChange={(e) => setFilterType(e.target.value.toString())}
            >
              <option value="">Select…</option>
              {loanTypesList.map((type) => (
                <option key={type.Id} value={type.Id}>
                  {type.Name}
                </option>
              ))}
            </select>

            <select
              className="form-select"
              style={{ width: "120px" }}
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value.toString())}
            >
              <option value="">Select…</option>
              {loanStatusList.map((status) => (
                <option key={status.Id} value={status.Id}>
                  {status.Name}
                </option>
              ))}
            </select>
            <div className="toolbar-spacer"></div>
            <span style={{ fontSize: "12px", color: "var(--text-muted)" }}>
              {totalRecords} records
            </span>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table className="mgmt-tbl">
              <thead>
                <tr>
                  <th>Employee</th>
                  <th>Type</th>
                  <th className="tr">Loan Amount</th>
                  <th className="tr">Disbursed On</th>
                  <th className="tr">Tenure</th>
                  <th className="tr">Monthly EMI</th>
                  <th className="tr">Repaid</th>
                  <th className="tr">Balance</th>
                  <th className="tr">Rem. EMIs</th>
                  <th>Progress</th>
                  <th style={{ textAlign: "center" }}>Status</th>
                  <th style={{ textAlign: "center" }} className="no-print">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>{filtered.rows}</tbody>
              <tfoot>
                <tr>
                  <td colSpan="2">PAGE TOTAL</td>
                  <td className="tr" Id="ft-LoanAmount">
                    {filtered.summary.ftAmt}
                  </td>
                  <td>—</td>
                  <td>—</td>
                  <td className="tr" Id="ft-MonthlyEMI">
                    {filtered.summary.ftEmi}
                  </td>
                  <td
                    className="tr"
                    Id="ft-rep"
                    style={{ color: "var(--success)" }}
                  >
                    {filtered.summary.ftRep}
                  </td>
                  <td
                    className="tr"
                    Id="ft-bal"
                    style={{ color: "var(--warning)" }}
                  >
                    {filtered.summary.ftBal}
                  </td>
                  <td colSpan="4">—</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <Paginator
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            rowsPerPageOptions={[10, 20, 50, 100]}
            onPageChange={onPageChange}
            template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          />
        </div>
      </div>

      {/* ADD/EDIT MODAL */}
      {showFormModal && (
        <div className="mo open" onClick={closeForm}>
          <div className="mb" onClick={(e) => e.stopPropagation()}>
            <div className="mh">
              <div className="icon-div">
                <i
                  className="fa-solid fa-hand-holding-dollar"
                  style={{ fontSize: "13px" }}
                ></i>
              </div>
              <h6>{editId ? "Edit Loan Record" : "Add Loan / Advance"}</h6>
              <button
                style={{
                  marginLeft: "auto",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#888",
                  lineHeight: 1,
                }}
                onClick={closeForm}
              >
                ×
              </button>
            </div>

            <div className="mbody">
              <div className="fsec">Employee &amp; Loan Details</div>
              <div className="fg2">
                <div>
                  <label className="form-label">
                    Employee <span style={{ color: "var(--danger)" }}>*</span>
                  </label>
                  <select
                    className="form-select w-100"
                    value={formData.EmployeeName}
                    onChange={(e) =>
                      setFormData({ ...formData, EmployeeName: e.target.value })
                    }
                  >
                    <option value="">Select…</option>
                    {EmployeeList.map((employee) => (
                      <option
                        key={employee.Id}
                        value={`${employee.FullName}|${employee.EmploymentId}`}
                      >
                        {employee.FullName} ({employee.EmploymentId})
                      </option>
                    ))}
                  </select>
                  {formErrors.EmployeeName && (
                    <div
                      className="text-danger"
                      style={{ fontSize: "12px", marginTop: "4px" }}
                    >
                      {formErrors.EmployeeName}
                    </div>
                  )}
                </div>
                <div>
                  <label className="form-label">
                    Loan Type <span style={{ color: "var(--danger)" }}>*</span>
                  </label>
                  <select
                    className="form-select w-100"
                    id="f-LoanTypeName"
                    value={formData.LoanTypeName}
                    onChange={handleInputChange}
                  >
                    <option value="">Select…</option>
                    {loanTypesList.map((type) => (
                      <option key={type.Id} value={type.Id}>
                        {type.Name}
                      </option>
                    ))}
                  </select>
                  {formErrors.LoanTypeName && (
                    <div
                      className="text-danger"
                      style={{ fontSize: "12px", marginTop: "4px" }}
                    >
                      {formErrors.LoanTypeName}
                    </div>
                  )}
                </div>
                <div>
                  <label className="form-label">
                    Loan Amount (₹){" "}
                    <span style={{ color: "var(--danger)" }}>*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control w-100"
                    id="f-amount"
                    placeholder="0"
                    min="1"
                    max="10000000"
                    value={formData.amount}
                    onChange={handleInputChange}
                  />
                  {formErrors.amount && (
                    <div
                      className="text-danger"
                      style={{ fontSize: "12px", marginTop: "4px" }}
                    >
                      {formErrors.amount}
                    </div>
                  )}
                </div>
                <div>
                  <label className="form-label">
                    Disbursement Date{" "}
                    <span style={{ color: "var(--danger)" }}>*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control w-100"
                    id="f-date"
                    value={formData.date}
                    onChange={handleInputChange}
                  />
                  {formErrors.date && (
                    <div
                      className="text-danger"
                      style={{ fontSize: "12px", marginTop: "4px" }}
                    >
                      {formErrors.date}
                    </div>
                  )}
                </div>
              </div>

              <div className="fsec">Repayment Terms</div>
              <div className="fg3">
                <div>
                  <label className="form-label">
                    Tenure (months){" "}
                    <span style={{ color: "var(--danger)" }}>*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control w-100"
                    id="f-Tenure"
                    min="1"
                    max="120"
                    placeholder="12"
                    value={formData.Tenure}
                    onChange={handleInputChange}
                  />
                  {formErrors.Tenure && (
                    <div
                      className="text-danger"
                      style={{ fontSize: "12px", marginTop: "4px" }}
                    >
                      {formErrors.Tenure}
                    </div>
                  )}
                </div>
                <div>
                  <label className="form-label">Monthly EMI (₹)</label>
                  <input
                    type="number"
                    className="form-control w-100"
                    id="f-MonthlyEMI"
                    placeholder="Auto"
                    min="1"
                    max="1000000"
                    value={formData.MonthlyEMI}
                    onChange={handleInputChange}
                  />
                  {formErrors.MonthlyEMI && (
                    <div
                      className="text-danger"
                      style={{ fontSize: "12px", marginTop: "4px" }}
                    >
                      {formErrors.MonthlyEMI}
                    </div>
                  )}
                </div>
                <div>
                  <label className="form-label">First Deduction</label>
                  <select
                    className="form-select w-100"
                    id="f-start"
                    value={formData.start}
                    onChange={handleInputChange}
                  >
                    <option value="">Select…</option>
                    {formonthList.map((m) => (
                      <option key={m.Id} value={m.Name}>
                        {m.Name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="fsec">Status &amp; Notes</div>
              <div className="fg2">
                <div>
                  <label className="form-label">Status</label>
                  <select
                    className="form-select w-100"
                    id="f-LoanStatusName"
                    value={formData.LoanStatusName}
                    onChange={handleInputChange}
                  >
                    <option value="">Select…</option>
                    {loanStatusList.map((status) => (
                      <option key={status.Id} value={status.Id}>
                        {status.Name}
                      </option>
                    ))}
                  </select>
                  {formErrors.LoanStatusName && (
                    <div
                      className="text-danger"
                      style={{ fontSize: "12px", marginTop: "4px" }}
                    >
                      {formErrors.LoanStatusName}
                    </div>
                  )}
                </div>
                <div>
                  <label className="form-label">Finance Reference No.</label>
                  <input
                    type="text"
                    className="form-control w-100"
                    id="f-FinanceReferenceNumber"
                    placeholder="FIN-2025-XXX"
                    maxLength="50"
                    value={formData.FinanceReferenceNumber}
                    onChange={handleInputChange}
                  />
                </div>
                <div style={{ gridColumn: "1 / -1" }}>
                  <label className="form-label">Notes</label>
                  <textarea
                    className="form-control w-100"
                    id="f-Notes"
                    rows="2"
                    placeholder="Additional notes…"
                    maxLength="500"
                    style={{ resize: "vertical" }}
                    value={formData.Notes}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              {formData.amount && formData.Tenure && (
                <div
                  Id="emiPrev"
                  style={{
                    display: "block",
                    background: "#f0fdf4",
                    border: "1px solid #bbf7d0",
                    borderRadius: "8px",
                    padding: "10px 14px",
                    marginTop: "14px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      color: "#166534",
                      textTransform: "uppercase",
                      letterSpacing: ".4px",
                      marginBottom: "6px",
                    }}
                  >
                    Repayment Preview
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "16px",
                      fontSize: "12.5px",
                    }}
                  >
                    <div>
                      <span style={{ color: "var(--text-muted)" }}>Loan:</span>{" "}
                      <strong>
                        ₹{parseFloat(formData.amount).toLocaleString("en-IN")}
                      </strong>
                    </div>
                    <div>
                      <span style={{ color: "var(--text-muted)" }}>
                        Monthly EMI:
                      </span>{" "}
                      <strong>
                        ₹
                        {parseFloat(formData.MonthlyEMI).toLocaleString(
                          "en-IN",
                        )}
                      </strong>
                    </div>
                    <div>
                      <span style={{ color: "var(--text-muted)" }}>
                        Tenure:
                      </span>{" "}
                      <strong>{formData.Tenure} months</strong>
                    </div>
                    <div>
                      <span style={{ color: "var(--text-muted)" }}>
                        Total Payable:
                      </span>{" "}
                      <strong>
                        ₹
                        {(
                          parseFloat(formData.MonthlyEMI) *
                          parseInt(formData.Tenure)
                        ).toLocaleString("en-IN")}
                      </strong>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="mfoot">
              <button className="btn btn-light" onClick={closeForm}>
                Cancel
              </button>
              <button className="btn btn-brand" onClick={saveLoan}>
                <i className="fa-solid fa-check"></i>{" "}
                {editId ? "Save Changes" : "Add Loan"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* STATEMENT MODAL */}
      {showStmtModal && stmtData && (
        <div className="mo open" onClick={closeStmt}>
          <div className="mb wide" onClick={(e) => e.stopPropagation()}>
            <div className="mh">
              <h6>Loan Repayment Statement</h6>
              <div style={{ marginLeft: "auto", display: "flex", gap: "8px" }}>
                <button
                  className="btn btn-light btn-sm"
                  onClick={() => window.print()}
                >
                  <i className="fa-solid fa-print"></i> Print
                </button>
                <button className="btn btn-light btn-sm" onClick={closeStmt}>
                  Close
                </button>
              </div>
            </div>
            <div style={{ padding: "24px" }}>
              {/* Statement content rendered from stmtData */}
              <div
                style={{
                  display: "flex",
                  gap: "16px",
                  marginBottom: "20px",
                  paddingBottom: "16px",
                  borderBottom: "2px solid var(--border)",
                  flexWrap: "wrap",
                }}
              >
                {/* ... (same as original statement header) */}
                {/* You can expand this section similarly if needed */}
              </div>
              {/* Full statement table can be built similarly using stmtData.rows */}
              <p style={{ textAlign: "center", color: "#666" }}>
                Statement table rendering logic is preserved in the original JS.
                You can extend the viewStmt function similarly.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* DELETE CONFIRM MODAL */}
      {showDelModal && (
        <div className="mo open" onClick={() => setShowDelModal(false)}>
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              width: "400px",
              padding: "24px",
              boxShadow: "0 24px 64px rgba(0,0,0,.18)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginBottom: "12px",
              }}
            >
              <div
                style={{
                  width: "34px",
                  height: "34px",
                  background: "#fee2e2",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--danger)",
                }}
              >
                <i className="fa-solid fa-trash"></i>
              </div>
              <h6 style={{ margin: 0, fontWeight: 700 }}>Delete Loan Record</h6>
            </div>
            <p
              Id="delMsg"
              style={{
                fontSize: "13px",
                color: "var(--text-mid)",
                margin: "0 0 18px",
              }}
            >
              Delete loan record for{" "}
              {loanStatusList.find((l) => l.Id === deleteId)?.EmployeeName}?
            </p>
            <div
              style={{
                display: "flex",
                gap: "8px",
                justifyContent: "flex-end",
              }}
            >
              <button
                className="btn btn-light"
                onClick={() => setShowDelModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-brand"
                style={{
                  background: "var(--danger)",
                  borderColor: "var(--danger)",
                }}
                onClick={confirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoanManagement;
